module.exports = __webpack_public_path__ + "images/kihnu/top-strip.png";